function StorageService(storage) {
  function getTokens() {
    return JSON.parse(storage.getItem('auth.tokens'))
  }

  function saveTokens(tokens) {
    storage.setItem('auth.tokens', JSON.stringify(Object.assign({}, getTokens(), tokens)))
  }

  function purgeTokens() {
    storage.removeItem('auth.tokens')
  }

  function getCurrentUser() {
    return JSON.parse(storage.getItem('auth.current'))
  }

  function saveCurrentUser(data) {
    storage.setItem('auth.current', JSON.stringify(data))
  }

  function purgeCurrentUser() {
    storage.removeItem('auth.current')
  }

  function getLocale() {
    return storage.getItem('locale')
  }

  function saveLocale(data) {
    storage.setItem('locale', data)
  }

  function purgeLocale() {
    storage.removeItem('locale')
  }

  function purge() {
    storage.clear();
  }

  return {
    getTokens,
    saveTokens,
    purgeTokens,
    getCurrentUser,
    saveCurrentUser,
    purgeCurrentUser,
    getLocale,
    saveLocale,
    purge,
    purgeLocale,
  }
}

export default StorageService(window.localStorage)
